"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeInferenceReports = mergeInferenceReports;
const toArray_1 = require("./Utils/toArray");
const ComponentParameterInferenceReportEntry_1 = require("./InferenceReports/ComponentParameterInferenceReportEntry");
const ValueValidation_1 = require("./Utils/ValueValidation");
function mergeInferenceReports(original, additional, opts = {}) {
    if (typeof original === 'undefined') {
        return additional ?? {};
    }
    if (typeof additional === 'undefined') {
        return original;
    }
    const boundaries = new Map();
    for (const boundary of [...(0, toArray_1.toArray)(original.boundaries), ...(0, toArray_1.toArray)(additional.boundaries)]) {
        boundaries.set(boundary.boundary.id, boundary);
    }
    const modes = new Map();
    for (const mode of [...(0, toArray_1.toArray)(original.modes), ...(0, toArray_1.toArray)(additional.modes)]) {
        modes.set(mode.mode.id, mode);
    }
    const functions = new Map();
    for (const func of [...(0, toArray_1.toArray)(original.functions), ...(0, toArray_1.toArray)(additional.functions)]) {
        const existing = functions.get(func.function.name);
        if (!existing || (func.priority ?? 0) >= (existing.priority ?? 0)) {
            functions.set(func.function.name, func);
        }
    }
    const resources = new Map();
    for (const resource of [...(0, toArray_1.toArray)(original.resources), ...(0, toArray_1.toArray)(additional.resources)]) {
        const existing = resources.get(resource.resource.name);
        if (!existing || (resource.priority ?? 0) >= (existing.priority ?? 0)) {
            resources.set(resource.resource.name, resource);
        }
    }
    const subModels = new Map();
    for (const submodel of [...(0, toArray_1.toArray)(original.submodels), ...(0, toArray_1.toArray)(additional.submodels)]) {
        const modelId = submodel.submodel.subModelId;
        if (subModels.has(modelId)) {
            subModels.set(modelId, {
                source: subModels.get(modelId)?.source ?? submodel.source,
                submodel: submodel.submodel,
                ...mergeInferenceReports(subModels.get(modelId), submodel),
            });
        }
        else {
            subModels.set(modelId, submodel);
        }
    }
    const result = {
        parameters: {},
    };
    if (boundaries.size > 0) {
        result.boundaries = Array.from(boundaries.values());
    }
    if (modes.size > 0) {
        result.modes = Array.from(modes.values());
    }
    if (functions.size > 0) {
        result.functions = Array.from(functions.values());
    }
    if (resources.size > 0) {
        result.resources = Array.from(resources.values());
    }
    if (subModels.size > 0) {
        result.submodels = Array.from(subModels.values());
    }
    if (additional.parameters) {
        result.parameters = Object.fromEntries(Object.entries(original.parameters ?? {}).filter(([, v]) => !v.disabled));
        for (const [key, value] of Object.entries(additional.parameters)) {
            if (value?.disabled) {
                continue;
            }
            if ((0, ValueValidation_1.isEmptyValue)(value)) {
                continue;
            }
            result.parameters[key] = (0, ComponentParameterInferenceReportEntry_1.pickBestComponentParameterInferenceReportEntry)(value, result.parameters[key]);
        }
    }
    else {
        result.parameters = original.parameters;
    }
    if (result.parameters && !Object.keys(result.parameters).length) {
        delete result.parameters;
    }
    if (original.signals) {
        if (additional.signals) {
            result.signals = [...original.signals, ...additional.signals];
        }
        else {
            result.signals = original.signals;
        }
    }
    else {
        result.signals = additional.signals;
    }
    if (opts.dedupeSignalEntries && result.signals) {
        result.signals = result.signals.reduce((acc, signal) => {
            for (const existing of acc) {
                if (signal.signalId === existing.signalId) {
                    const deduped = opts.dedupeSignalEntries(existing, signal);
                    if (deduped) {
                        return [...acc.filter((s) => s !== existing), deduped];
                    }
                }
            }
            acc.push(signal);
            return acc;
        }, []);
    }
    result.postInferenceActions = [...(original.postInferenceActions ?? []), ...(additional.postInferenceActions ?? [])];
    if (!result.postInferenceActions.length) {
        delete result.postInferenceActions;
    }
    return result;
}
//# sourceMappingURL=MergeInferenceReports.js.map